import { render, staticRenderFns } from "./PublishedEvent.vue?vue&type=template&id=49d6fb9d&scoped=true&"
import script from "./PublishedEvent.vue?vue&type=script&lang=js&"
export * from "./PublishedEvent.vue?vue&type=script&lang=js&"
import style0 from "./PublishedEvent.vue?vue&type=style&index=0&id=49d6fb9d&prod&lang=scss&scoped=true&"
import style1 from "./PublishedEvent.vue?vue&type=style&index=1&id=49d6fb9d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d6fb9d",
  null
  
)

export default component.exports